import React from 'react';
import doneAnimation from '../../images/done.gif';

const SuccessCard = ({ mobileNumber = null }) => {

    return (
        <div className='success_card_cntnr'>
            <div className='success_card_content'>
                <div className='thnk-you-img'>
                    <img src={doneAnimation} alt='done_img' />
                </div>
                <p className='success_card_title'>Policy verification has already been done</p>
                <p className='success_card_text'>There are no pending policy verifications under the mobile number {mobileNumber} </p>
            </div>
        </div>
    );
};

export default SuccessCard;